import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'module-tsl-ui-elements';
import { connect } from 'react-redux';
import { addToProfile } from '../../../modules/Filters';
import { mzEmit } from '../../../app/helpers';

const START_FADING_AFTER = 7000;
const FADE_DURATION = 5000; // when changing this, must change css too

class AddToProfileBubble extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rendered: false,
      whatsThisOpen: false,
      isFading: false,
    };
    this.addToProfile = this.addToProfile.bind(this);
    this.toggleWhatsThis = this.toggleWhatsThis.bind(this);
    this.stopFade = this.stopFade.bind(this);
    this.startFade = this.startFade.bind(this);
    this.showBubble = this.showBubble.bind(this);
    this.fadeTimeoutId = null;
  }

  componentDidMount() {
    this.showBubble();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.label !== this.props.label) {
      this.showBubble();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.rendered && !this.state.rendered) {
      document.body.removeEventListener('click', this.closeFn);
    }
    if (!prevState.rendered && this.state.rendered) {
      if (!this.closeFn) {
        this.setCloseFn();
      }
      document.body.addEventListener('click', this.closeFn);
    }
  }

  componentWillUnmount() {
    this.setState({ rendered: false });
    document.body.removeEventListener('click', this.closeFn);
  }

  showBubble() {
    this.setState({ rendered: true });
    this.startFade();
    mzEmit({ eventTitle: 'jobs.v2.addToProfile', payload: { event: 'rendered' } }, 'DISPLAY');
  }

  setCloseFn() {
    this.closeFn = ({ target, closeBtnClicked = false, maybeLaterClicked = false, fadedOut = false } = {}) => {
      if (this.fadeTimeoutId) clearTimeout(this.fadeTimeoutId);

      if (!target) {
        mzEmit({ eventTitle: 'jobs.v2.addToProfile', payload: { event: 'closed', clickedOutside: false, closeBtnClicked, maybeLaterClicked, fadedOut } }, 'CLOSE');
        return this.setState({ rendered: false });
      }

      const clickedInsideBubble = Array.from(document.getElementsByClassName('add-to-profile-bubble'))[0].contains(target);
      if (!clickedInsideBubble) {
        mzEmit({ eventTitle: 'jobs.v2.addToProfile', payload: { event: 'closed', clickedOutside: true, closeBtnClicked, maybeLaterClicked, fadedOut } }, 'CLOSE');
        this.setState({ rendered: false });
      }
    };
  }

  addToProfile() {
    mzEmit({ eventTitle: 'jobs.v2.addToProfile', payload: { event: 'adding-to-profile', label: this.props.label } }, 'SUBMIT');
    this.props.addToProfile(this.props.dataToAdd);
  }

  toggleWhatsThis() {
    mzEmit({ eventTitle: 'jobs.v2.addToProfile', payload: { event: 'whats-this-toggled', opened: !this.state.whatsThisOpen } }, 'CLICK');
    this.setState({ whatsThisOpen: !this.state.whatsThisOpen });
  }

  startFade() {
    if (this.fadeTimeoutId) clearTimeout(this.fadeTimeoutId);
    this.fadeTimeoutId = setTimeout(() => {
      this.setState({ isFading: true });
      this.fadeTimeoutId = setTimeout(() => {
        if (!this.state.rendered) return;
        this.closeFn({ fadedOut: true });
      }, FADE_DURATION);
    }, START_FADING_AFTER);
  }
  
  stopFade() {
    if (this.fadeTimeoutId) clearTimeout(this.fadeTimeoutId);
    this.setState({ isFading: false });
  }

  render() {
    return <div className={`add-to-profile-bubble${this.state.isFading ? ' fading' : ''}`} style={{ display: this.state.rendered ? 'block' : 'none' }} onMouseOver={this.stopFade} onMouseOut={this.startFade}>
      {this.props.isAdded
        ? <div>
            <div>We have added <strong>{this.props.label}</strong>.</div>
            <hr />
            <div>Want to tell us more, so we can help find your perfect role?</div>
            <div className="add-to-profile-buttons">
              <Button
                theme="tertiary"
                size="sm"
                type="button"
                onClick={() => {
                  mzEmit({ eventTitle: 'jobs.v2.addToProfile', payload: { event: 'navigated-to-widget' } }, 'CLICK')
                    .then(() => document.location.href = "/widget/int-talent-capture/international");
                }}
              >
                Yes, please
              </Button>
              <a
                href="#"
                onClick={() => this.closeFn({ maybeLaterClicked: true })}
              >
                Maybe later
              </a>
            </div>
          </div>
        : <div>
            <div className="add-to-profile-title">Do you want to add <strong>{this.props.label}</strong> to locations you're interested in?</div>
            <div className="add-to-profile-buttons">
              <Button
                theme="tertiary"
                size="sm"
                type="button"
                onClick={this.addToProfile}
              >
                Yes, please
              </Button>
              <a
                href="#"
                onClick={this.toggleWhatsThis}
              >
                What's this for?
              </a>
            </div>
            <div className={`whats-this-for${this.state.whatsThisOpen ? ' open' : ''}`}>
              We'll add this to locations you're interested in in your <a href="/member/me/career-profile/career-preferences">Career Preferences</a>, which will allow better job recommendations. <a href="/terms/privacy-policy">View full privacy policy.</a>
            </div>
          </div>
      }
      <button class="tds-btn tds-btn--sm tds-btn--with-icon tds-btn--icon-only tds-popover__button tds-popover__button--alternative tds-btn--tertiary-inverse bubble-close-button" onClick={() => this.closeFn({ closeBtnClicked: true })} ><i class="icon icon-close icon-sm icon-white"></i></button>
    </div>;
  }
}

AddToProfileBubble.propTypes = {
  label: PropTypes.string,
  addToProfile: PropTypes.func,
  dataToAdd: PropTypes.object,
  isAdded: PropTypes.bool,
};

export default connect(() => ({}), (dispatch) => ({
  addToProfile: (options) => dispatch(addToProfile(options)),
}))(AddToProfileBubble);
